var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarCollapse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6875 11.3125L4.40625 9H10C10.5312 9 11 8.5625 11 8C11 7.46875 10.5312 7 10 7H4.40625L6.6875 4.71875C6.875 4.53125 7 4.28125 7 4C7 3.75 6.875 3.5 6.6875 3.3125C6.3125 2.90625 5.65625 2.90625 5.28125 3.3125L1.28125 7.3125C0.875 7.6875 0.875 8.34375 1.28125 8.71875L5.28125 12.7188C5.65625 13.125 6.3125 13.125 6.6875 12.7188C7.09375 12.3438 7.09375 11.6875 6.6875 11.3125ZM13 3V13C13 13.5625 13.4375 14 14 14C14.5312 14 15 13.5625 15 13V3C15 2.46875 14.5312 2 14 2C13.4375 2 13 2.46875 13 3Z",
    fill: "#193154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCollapse);
export default __webpack_public_path__ + "static/media/sidebar_collapse.41aaf46e2fcebbfc664d52e98cbec48c.svg";
export { ForwardRef as ReactComponent };